import { useTheme } from "@mui/material/styles";
import { categoryTagStyles } from "../styles/categoryTagStyles";

type CategoryTagProps = {
  value: {
    name: string;
    color: string;
  };
};

export const CategoryTag = ({
  value,
}: {
  value: CategoryTagProps["value"];
}) => {
  const theme = useTheme();
  const styles = categoryTagStyles(theme);

  if (!value || !value.name || !value.color) {
    return null;
  }

  return (
    <div style={styles.container as React.CSSProperties}>
      <div
        title={value.name}
        style={{
          ...(styles.colorCircle as React.CSSProperties),
          backgroundColor: value.color,
        }}
      >
        {value.name.charAt(0).toUpperCase()}
      </div>
      <span>{value.name}</span>
    </div>
  );
};
